// Elements and matchups are data. Adding a ninth element means a row here,
// entries in BEATS, and art; no rule code changes.
export const ELEMENTS = {
  flame: { name: 'Flame', color: '#e0662a' },
  tide: { name: 'Tide', color: '#3d8fd1' },
  grove: { name: 'Grove', color: '#5a9a3e' },
  storm: { name: 'Storm', color: '#8a6fe0' },
  stone: { name: 'Stone', color: '#8c8a90' },
  frost: { name: 'Frost', color: '#7fc8e8' },
  shade: { name: 'Shade', color: '#6a4f8a' },
  light: { name: 'Light', color: '#e2c35a' },
} as const;

export type Element = keyof typeof ELEMENTS;
export const ELEMENT_IDS = Object.keys(ELEMENTS) as Element[];

/** attacker -> defenders it hits hard */
export const BEATS: Record<Element, Element[]> = {
  flame: ['grove', 'frost'],
  tide: ['flame', 'stone'],
  grove: ['tide', 'stone'],
  storm: ['tide', 'frost'],
  stone: ['flame', 'storm'],
  frost: ['grove', 'storm'],
  shade: ['light'],
  light: ['shade'],
};

export const STRONG = 1.5;
export const WEAK = 0.67;

/**
 * The hunt chart for your creature's blows on a wild (battle design 3.2): ×2 strong, ×0.5 weak, multiplied over
 * both of the wild's elements (×4 / ×0.25). A wild's blows on you use the base chart, `matchup`.
 */
export const HUNT_STRONG = 2;
export const HUNT_WEAK = 0.5;

/** Multiplier for an attack of `atk` element against a defender with these elements. */
export function matchup(atk: Element, def: readonly Element[], strong = STRONG, weak = WEAK): number {
  let m = 1;
  for (const d of def) {
    if (BEATS[atk].includes(d)) m *= strong;
    else if (BEATS[d].includes(atk)) m *= weak;
  }
  return m;
}

/**
 * The PvP chart (Arena, Halls, duels, tournaments; Guild War keeps the base chart): ×1.1 strong, ×0.9 weak (×1.21 / ×0.81 against two
 * elements). Retune 2026-10-15 (battle-consistency.md): on the base chart a correct counter at equal Power and level
 * won every PvP fight; on this one it is favoured, about 80%, and team-building still decides the rest.
 */
export const PVP_STRONG = 1.1;
export const PVP_WEAK = 0.9;
export function pvpMatchup(atk: Element, def: readonly Element[]): number {
  return matchup(atk, def, PVP_STRONG, PVP_WEAK);
}

/** Your blow on a wild: the hunt chart (×2 / ×0.5). */
export function huntMatchup(atk: Element, def: readonly Element[]): number {
  return matchup(atk, def, HUNT_STRONG, HUNT_WEAK);
}
